import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { CreditCard } from 'lucide-react';

export class TempCreditDsr extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <CreditCard color="#31af36" />
            <h3>Temp Credit</h3>
          </header>
          <main>
            <table className="dsr" data-name="Temp Credit Collection">
              <thead>
                <tr data-header={true}>
                  <th>#</th>
                  <th>Cashier</th>
                  <th>Customer </th>
                  <th> Amount given </th>
                  <th> Amount received </th>
                  <th> Pending amount </th>
                  <th> Payment mode </th>
                </tr>
              </thead>
              <tbody>
                {summary.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>
                        {' '}
                        {val.cashier.first_name + val.cashier.last_name}{' '}
                      </td>
                      <td>{val.customer_name}</td>
                      <td>{formatCurrency(val.amount_given)}</td>
                      <td> {formatCurrency(val.amount_received)} </td>
                      <td> {formatCurrency(val.pending_amount)} </td>
                      <td> {val.payment_mode} </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
